export const werkstattMenu = [
  {
    displayName: 'Werkstatt',
    path: '#werkstatt'
  },
  {
    displayName: 'Werkzeuge',
    path: '#werkzeuge'
  },
  {
    displayName: '3-D Gestaltung',
    path: '#gestaltung'
  },
  {
    displayName: 'Material und Edelsteine',
    path: '#material-und-edelsteine'
  },
  {
    displayName: 'Botschafter des Handwerks',
    path: '#botschafter'
  },
];

export const editionMenu = [
  {
    displayName: 'Kommunion',
    path: '#kommunion'
  },
  {
    displayName: '18. Geburtstag',
    path: '#geburtstag'
  },
  {
    displayName: 'Hochzeit',
    path: '#hochzeit'
  },
  {
    displayName: 'Geburt',
    path: '#geburt'
  },
  {
    displayName: 'Besondere Erinnerungen',
    path: '#erinnerungen'
  },
];